import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    startBuDimStatus: 'idle',
    startBuDimError: undefined as any,
    loadParamsBuDimStatus: 'idle',
    loadParamsBuDimError: undefined as any,
    loadColumnConfigsStatus: 'idle',
    loadColumnConfigsError: undefined as any,

    buDimList: [] as any[],
    colConfigs: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,
}

export const startBuDim = createAsyncThunk('buDimSlice/startBuDim', async (buDim: any, { rejectWithValue }: any) => {
    const res = await client.post(`/api/ixweb/startBuDim/`, prepareData(buDim))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...buDim, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const loadParamsBuDim = createAsyncThunk('buDimSlice/loadParamsBuDim', async (_, { rejectWithValue }: any) => {
    const res = await client.get(`/api/ixweb/loadParamsBuDim/`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})
export const loadColumnConfigs = createAsyncThunk('buDimSlice/loadColumnConfigs', async (_, { rejectWithValue }: any) => {
    const res = await client.get(`/api/ixweb/budim/`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})

const BuDimSlice = createSlice({
    name: 'buDimSlice',
    initialState,
    reducers: {
        resetstartBuDimError: (state) => {
            state.startBuDimError = undefined
        },
        resetloadParamsBuDimError: (state) => {
            state.loadParamsBuDimError = undefined
        },
        resetloadColumnConfigs: (state) => {
            state.colConfigs = undefined
            state.loadColumnConfigsError = undefined
        },
        resetloadColumnConfigsError: (state) => {
            state.loadColumnConfigsError = undefined
        },
        removeFromBuDimListById: (state, action) => {
            state.buDimList = state.buDimList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(startBuDim.pending, (state) => {
            state.startBuDimStatus = 'pending'
            state.startBuDimError = undefined
        })
        builder.addCase(startBuDim.fulfilled, (state, action) => {
            state.startBuDimStatus = 'idle'

            state.buDimList = [...state.buDimList, action.payload]
        })
        builder.addCase(startBuDim.rejected, (state, action) => {
            state.startBuDimStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startBuDimError = action.error.message
            } else {
                state.startBuDimError = action.payload
            }
        })

        builder.addCase(loadParamsBuDim.pending, (state) => {
            state.loadParamsBuDimStatus = 'pending'
            state.loadParamsBuDimError = undefined
        })
        builder.addCase(loadParamsBuDim.fulfilled, (state, action) => {
            state.loadParamsBuDimStatus = 'idle'

            state.buDimList = action.payload
        })
        builder.addCase(loadParamsBuDim.rejected, (state, action) => {
            state.loadParamsBuDimStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadParamsBuDimError = action.error.message
            } else {
                state.loadParamsBuDimError = action.payload
            }
        })

        builder.addCase(loadColumnConfigs.pending, (state) => {
            state.loadColumnConfigsStatus = 'pending'
            state.loadColumnConfigsError = undefined
        })
        builder.addCase(loadColumnConfigs.fulfilled, (state, action) => {
            state.loadColumnConfigsStatus = 'idle'

            state.colConfigs = action.payload
        })
        builder.addCase(loadColumnConfigs.rejected, (state, action) => {
            state.loadColumnConfigsStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadColumnConfigsError = action.error.message
            } else {
                state.loadColumnConfigsError = action.payload
            }
        })

    }
})

export const {
    resetstartBuDimError,
    resetloadParamsBuDimError,
    resetloadColumnConfigs,
    resetloadColumnConfigsError,
    removeFromBuDimListById,
    setFilterValues,
    setFilterLookupValue,
} = BuDimSlice.actions
export default BuDimSlice.reducer
